import { Pagination } from "antd";

export const PaginationView = ({
  total = 0,
  setFilter,
  current,
}: {
  total: number;
  setFilter?: any;
  current?: number;
}) => {
  return (
    <div className="flexNullCenter">
      <div className="flexGrow">
        <Pagination
          size="small"
          current={current || 1}
          defaultCurrent={1}
          total={total}
          onChange={(page) => {
            setFilter((prev: any) => ({ ...prev, page }));
          }}
        />
      </div>
      <div className="font12 grey">{total} items</div>
    </div>
  );
};
